import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { controlHasError } from '../../lib/errorHandler'

class SrednioroczneZatrudnienie extends React.Component {
  state = {
    isEditing: false,
    localValue: '',
  }

  formatValue = (value) => {
    if (value === null || value === undefined || value === '') return ''
    const numericValue = Number(value)
    if (Number.isNaN(numericValue)) return String(value)
    return numericValue.toFixed(2)
  }

  handleFocus = () => {
    this.setState({
      isEditing: true,
      localValue: this.props.data.LiczbaEtatow ?? '',
    })
  }

  handleChange = (e) => {
    this.setState({ localValue: e.target.value })
  }

  handleBlur = () => {
    const formattedValue = this.formatValue(this.state.localValue)
    this.setState({ isEditing: false, localValue: formattedValue })
    this.props.onSetSectionData('LiczbaEtatow', formattedValue)
  }

  render() {
    const displayValue = this.state.isEditing
      ? this.state.localValue
      : this.formatValue(this.props.data.LiczbaEtatow)
    return (
      <ExpandablePanel title="ŚREDNIOROCZNE ZATRUDNIENIE W PRZELICZENIU NA PEŁNE ETATY">
        <form autoComplete="off" className="srednioroczneZatrudnienie">
          <FormControl component="fieldset">
            <TextField
              error={controlHasError(this.props.errors, 'LiczbaEtatow')}
              name="LiczbaEtatow"
              label="Liczba etatów"
              title={this.props.data.LiczbaEtatow}
              value={displayValue}
              type="number"
              inputProps={{ min: 0, step: '0.01' }}
              helperText="Liczbę należy zaokrąglić do dwóch miejsc po przecinku"
              onFocus={this.handleFocus}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default SrednioroczneZatrudnienie
